import styled from "styled-components";
import { getClassForStatus } from "../../../../../constant/status";
import { resolveJourneyColors } from "../../../../../constant/journeyStatus";

/**
 * Status Component
 *
 * Renders a status tag with a colored box and a tick indicator.
 *
 * @param {Object} props
 * @param {string} props.statusName - The name of the status (e.g., "Delivered", "Receipted").
 * @param {"journey"|undefined} props.palette - When `"journey"`, uses PO/shipment journey colors.
 */

export const Status = ({ statusName, palette }) => {
  const journeyColors = palette === "journey" ? resolveJourneyColors(statusName) : null;

  if (journeyColors) {
    return (
      <StatusCss
        className="statusBox journeyStatus"
        $text={journeyColors.text}
        $bg={journeyColors.bg}
        $dot={journeyColors.dot}
      >
        <div className="tickBox"></div>
        {statusName}
      </StatusCss>
    );
  }

  return (
    <StatusCss className={`statusBox ${getClassForStatus(statusName)}`}>
      <div className="tickBox"></div>
      {statusName}
    </StatusCss>
  );
};

const StatusCss = styled.div`
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #e1fcef;
  border-radius: 4px;
  padding: 0 8px;
  width: max-content;

  .tickBox {
    width: 6px;
    height: 6px;
    background-color: #38a06c;
    border-radius: 2px;
  }

  &.journeyStatus {
    color: ${({ $text }) => $text};
    background-color: ${({ $bg }) => $bg};
    > .tickBox {
      background-color: ${({ $dot }) => $dot};
    }
  }

  &.orange {
    color: #aa5b00;
    background-color: #fcf2e6;
    > .tickBox {
      background-color: #c97a20;
    }
  }

  &.red {
    color: #cf324a;
    background-color: #ffedef;
    > .tickBox {
      background-color: #cf324a;
    }
  }
  &.blue {
    color: #262641;
    background-color: #aad3ff;
    > .tickBox {
      background-color: #262641;
    }
  }

  &.grey {
    color: #222;
    background-color: #d9d9d9;
    > .tickBox {
      background-color: #222229;
    }
  }
  &.green {
    color: #14804a;
    background-color: #e1fcef;
    > .tickBox {
      background-color: #38a06c;
    }
  }

  &.yellow {
    color: #854d0e;
    background-color: #fef9c3;
    > .tickBox {
      background-color: #ca8a04;
    }
  }
`;
